import * as React from "react";
import * as ReactDOM from "react-dom";
import * as $ from "jquery";

import Modal from "../lib/components/Modal";
interface ILoginCompProps {

}

interface ILoginCompState {
    email : string;
    password : string;
    from_url : string;
    errors : Array<string>;
}

class LoginComp extends React.Component<ILoginCompProps, ILoginCompState>{

    constructor(props:ILoginCompProps){
          super(props);
          // set initial state
          this.state = this.getInitState();
    }

    componentDidMount() {
        this.setState(this.getInitState());
    }

    protected getInitState():any{
        return {
            email: '',
              password: '',
              from_url: window.location.pathname,
            errors : []
        };
    }

    emailChangeHandler(event) {
      this.setState({
          email: event.target.value.toString().trim()
      } as ILoginCompState);
    }

    passwordChangeHandler(event):void {
      this.setState({
          password: event.target.value.toString().trim()
      } as ILoginCompState);
    }

      submitHandler(e):void {
          e.preventDefault();
          if ( this.checkValid() ) {
              $.ajax({
                  data:{
                      email:        this.state.email,
                      password:     this.state.password,
                      from_url:     this.state.from_url
                  },
                  type:               "POST",
                  url:                '/loginUser',
                  contentType:        "application/x-www-form-urlencoded;charset=UTF-8",
                  success: (data) => {
                      if ( data.success !== undefined
                         && data.success === true ) {
                          window.location.href = data.redirect_to;
                      }else if( data.error !== undefined ){
                          this.setState({
                              errors : [ data.error ]
                          } as ILoginCompState);
                      }
                  }
              });
          }
      }

      checkValid():boolean{
          var err:Array<string> = [];

          if ( this.state.email === '' ) {
              err.push('Kérem, adja meg az e-mail címét!');
          }else{
              var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              if ( re.test(this.state.email) === false ) {
                  err.push('Hibás e-mail cím!');
              }
          }

          if ( this.state.password === '' ) {
              err.push('Kérem, adja meg az jelszavát!');
          }
          this.setState({
              errors : err
          } as ILoginCompState);
          return err.length === 0;
      }

    render() {
        var errors = this.state.errors;
        return (
              <div>
                <form onSubmit={ e => this.submitHandler(e) } action="" method="POST" role="form">

                    <div className="row">
                        <div className="box right">
                            <label htmlFor="email">E-mail cím:</label>
                        </div>
                        <div className="box">
                            <input type="email" onChange={ e => this.emailChangeHandler(e) }  name="email" id="email" placeholder="E-mail cím" value={this.state.email} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="box right">
                            <label htmlFor="password">Jelszó:</label>
                        </div>
                        <div className="box">
                            <input type="password" onChange={ e => this.passwordChangeHandler(e) } name="password" id="password" placeholder="Jelszó" value={this.state.password} />
                        </div>
                    </div>
                    <div className="alert alert-danger">
                        {errors.map((item:any) => {
                            return <div>{item}</div>;
                        })}
                    </div>

                    <div className="row">
                        <input type="hidden" name="from_url" value={this.state.from_url} />
                        <div className="box full right">
                            <button type="submit" className="btn btn-primary">Bejelentkezés</button>
                        </div>
                    </div>
                </form>
              </div>
        );
    }
}
export default class InitLoginComp {
    constructor() {
        var div: HTMLDivElement = document.getElementById('login_comp') as HTMLDivElement;
        if (div !== null) {
            ReactDOM.render(< LoginComp/>, div);
            new Modal($('#login_modal'), 'Bejelentkezés', '', true);
        }
    }
}



// WEBPACK FOOTER //
// ./components/LoginComp.tsx